<template>
  <div class="place-page-wrap h-100">
    <PlaceTutorial :hasRelatedPlaces="hasRelatedPlaces" v-if="showPlaceTutorial"></PlaceTutorial>
    <PageNotFound v-if="pageNotFound"></PageNotFound>
    <div v-else class="container d-flex flex-column h-100">

      <AddContentToUserGroup :type="'place'" :id="placeId" :img="likeImage" :name="placeName" v-if="userGroupAdd" @close="userGroupAdd = false;"></AddContentToUserGroup>

      <UserWishSupport :placeId="placeId" :placeName="placeName" v-if="showUserWishSupport" @close="showUserWishSupport = false"></UserWishSupport>

      <div class="row h-100">

        <div class="col-lg-7 col-md-7 col-12">

          <Images :imageData="imageData" v-if="showImages"></images>

          <Map :mapData="placeMapData" :startup="startup" :primaryPlaceTag="primaryTag.id" v-else>
            <RouteDetails :routeData="routeResult" v-if="showRouteDetails" :placePage="true" :placeName="placeName"></RouteDetails>
          </Map>

          <div class="row place-basic-information-box white-box">

            <div class="col-12 p-0">
              <Toolbar :type="'place'" :tagId="tagId" :id="placeId" :name="placeName" :img="likeImage" :noImage="noImage" :showImages="showImages"  @switchBetweenImageAndMap="showImages = !showImages" @addItemToUserGroup="userGroupAdd = true"></Toolbar>
            </div>

            <div class="col-12 place-info">
              <h1 class="place-headline d-none d-sm-block" v-if="placeName != ''">
                {{ placeName }}<br>
              </h1>

              <div id="user-wish-support-btn" class="toolbar-btn blue-text" aria-label="Bak op om dette ønske" role="button" v-if="tagId == 342" @click="showUserWishSupport = true;" tabindex="0">
                <span class="material-icons" aria-hidden="true">thumb_up</span>
                <br>
                <strong>Bak op om</strong>
              </div>

              <div class="blue-text" id="directions-btn">
                <router-link :to="{path: '/directions/place/'+tagId+','+placeId}" aria-label="Beregn rute til stedet">
                  <span class="material-icons" aria-hidden="true">directions</span><br>
                  <strong>Rute til</strong>
                </router-link>
              </div>

              <span v-if="dataReady">
                <span v-if="placeData[0].geometry.roadname">{{placeData[0].geometry.roadname+' '}}</span>
                <span v-if="placeData[0].geometry.housenumber">{{placeData[0].geometry.housenumber}}<br></span>
                <span v-if="placeData[0].geometry.postal">{{placeData[0].geometry.postal+' '+placeData[0].geometry.postalName}}</span>
              </span>
            </div>

            <div class="col-12 place-tags">
              <p class="sr-only">Liste over emner, som det valgte sted er tilknyttet.</p>
              <div class="place-tags-div">
                <strong>
                  <router-link :to="{path: '/tag/'+primaryTag.id}">{{ primaryTag.name }}</router-link>
                </strong>
              </div>
              <template v-for="(otherTag, index) in otherTags">
                <div class="place-tags-div other-tags-div">
                  <router-link :to="{path: '/tag/'+otherTag.id}">{{ '| '+otherTag.name }}</router-link>
                </div>
              </template>
            </div>

            <div id="place-related-mobile" class="col-12 place-related d-md-none" v-if="relatedPlaces.length > 0">
              <RelatedPlaces :relatedPlaces="relatedPlaces"></RelatedPlaces>
            </div>

            <div id="place-contact" class="col-12" v-if="dataReady" aria-label="Kontakt info">
              <span class="input-headline" v-if="placeData[0].properties.prop38 || placeData[0].properties.prop41 || placeData[0].properties.prop42 || placeData[0].properties.prop104 || placeData[0].properties.prop104">Kontakt</span>
              <div class="place-info-contact-value" v-if="placeData[0].properties.prop38">
                <span><a :href="placeData[0].properties.prop38.value" target="_blank">Gå til hjemmeside</a></span>
              </div>

              <div class="place-info-contact-value" v-if="placeData[0].properties.prop41">
                <span><a :href="'mailto:'+placeData[0].properties.prop41.value" target="top">{{placeData[0].properties.prop41.value}}</a></span>
              </div>

              <div class="place-info-contact-value" v-if="placeData[0].properties.prop42">
                <span><a class="phone-number" :href="'tel:'+placeData[0].properties.prop42.value">{{placeData[0].properties.prop42.value}}</a></span>
              </div>

              <div class="place-info-contact-value" v-if="placeData[0].properties.prop104">
                <span><a :href="placeData[0].properties.prop104.value" target="_blank">Følg på Facebook</a></span>
              </div>

              <div class="place-info-contact-value" v-if="placeData[0].properties.prop139">
                <span><a :href="placeData[0].properties.prop139.value" target="_blank">Følg på Instagram</a></span>
              </div>
            </div>

          </div>
        </div>

        <!-- Right side box PC -->
        <div class="col-lg-5 col-md-5 col-12 place-information-wrap no-pad-both-xs no-pad-both-sm">
          <div class="col-12 place-information white-box">

            <div id="place-related-pc" class="place-related d-none d-md-block" v-if="relatedPlaces.length > 0">
              <RelatedPlaces :relatedPlaces="relatedPlaces"></RelatedPlaces>
            </div>

            <div v-if="['51', '56', '252', '253', '386'].indexOf(this.tagId) > -1" class="extra-info">
              Husk altid at orientere dig om parkeringsbetingelserne på skiltene på stedet. Informationerne her på Odense Rundt er vejledende.
            </div>

            <div v-if="hasRouteData" class="extra-info">
              <span class="input-headline">{{ placeData[0].properties.prop105.name }}</span>
              <span class="float-right"> {{ placeData[0].properties.prop105.value }}</span>
              <router-link :to="'routeDescription'" append><br>Vis turforslaget trin for trin</router-link>
            </div>

            <ul v-html="this.placeInfoFull" id="place-info-full"></ul>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import ContentController from '@/assets/ContentController.js'
import DataManager from '@/assets/DataManager.js'
import DataFunctions from '@/assets/DataFunctions.js'
import Map from '@/components/map/Map.vue'
import Toolbar from '@/components/Toolbar.vue'
import Images from '@/components/Images.vue'
import RelatedPlaces from '@/components/place/RelatedPlaces.vue'
import Dato from '@/assets/Dato.js'
import RouteCalculator from '@/assets/routePlanner/RouteCalculator.js'
import MapFunctions from '@/assets/MapFunctions.js'
import RouteDetails from '@/components/directions/RouteDetails.vue'
import PageNotFound from '@/components/PageNotFound.vue'
import AddContentToUserGroup from '@/components/profile/AddContentToUserGroup.vue'
import UserWishSupport from '@/components/place/UserWishSupport.vue'
import LiveData from '@/assets/LiveData.js'
import axios from 'axios'
import PlaceTutorial from '@/components/tutorials/PlaceTutorial.vue'

export default {
  data() {
    return {
      tagData: {},
      primaryTag: {},
      otherTags: {},
      placeData: [],
      placeMapData: [],
      RouteCalculator: false,
      routeResult: {},
      showRouteDetails: false,
      relatedPlaces: [],
      dataReady: false,
      placeName: '',
      placeInfoFull: '',
      imageData: [],
      likeImage: false,
      showImages: true,
      pageNotFound: false,
      userGroupAdd: false,
      showUserWishSupport: false,
      userWishLikes: false,
      hasRouteData: false,
      liveDataTimeout: false,
      noImage: false,
      showPlaceTutorial: false,
      hasRelatedPlaces: false,
    }
  },
  props: {
    tagId: {
      type: String,
      required: true
    },
    placeId: {
      type: String,
      required: true
    },
    startup: {
      type: String,
    }
  },
  components: {
    Map, Toolbar, Images, RelatedPlaces, RouteDetails, PageNotFound, AddContentToUserGroup, UserWishSupport, PlaceTutorial
  },
  watch: {
    $route(to, from) {
      this.dataReady = false;
      this.getPlaceData();
    }
  },
  beforeCreate() {
    this.$root.$emit('toggleLoadingScreen', true);
  },
  created() {
    this.getPlaceData();
  },
  mounted() {
    //this.$el.addEventListener('click', this.checkLink);
    this.$HelperFunctions.setScreenReaderFocus();
  },
  beforeDestroy() {
    clearInterval(this.liveDataTimeout);
  },
  methods: {
    checkLink(event) {
      console.log(event);
      event.preventDefault();
      var href = event.target.href;
      if(href.indexOf('odenserundt.dk') != -1) {
        let split = href.split('odenserundt.dk');
				this.$router.push(split[1]);
      }
      else {
        window.open(href, '_system', '');
      }
    },
    getPlaceData() {
      if(this.tagId != undefined && this.tagId != 'undefined') {
        DataManager.getData([
          DataManager.newTags+this.tagId+'-dk-full.json',
        ], (response) => {
          this.tagData = response[0].data;
          this.placeData = [];
          this.placeMapData = [];
          this.imageData = [];
          this.relatedPlaces = [];
          this.placeInfoFull = '';
          this.showRouteDetails = false;

          this.dataReady = true;
          let temp = this.tagData.features.filter(feature => feature.id == this.placeId);
          if(temp.length != 0) {
            temp.forEach(item => this.placeData.push(item));
            this.getPlaceMapData();
            this.getPlaceTagInfo();
            this.placeName = temp[0].name;
            this.$HelperFunctions.scrollToTop();
            this.$HelperFunctions.setPageTitle(this.placeName);
            console.log(this.placeData[0]);
            this.$HelperFunctions.checkForLiveData([this.placeData[0]]).then((liveDataFound) => {
              if(liveDataFound) {
                LiveData.getLiveData().then(() => {
                  this.generatePlaceFullInfo();
                  this.liveDataTimeout = setInterval(() => {
                    LiveData.getLiveData().then(() => {
                      this.generatePlaceFullInfo();
                    });
                  }, 60000);
                });
              }
              else {
                this.generatePlaceFullInfo();
              }
            });
          }
          else {
            this.pageNotFound = true;
            this.$root.$emit('toggleLoadingScreen', false);
          }
        });
      }
      else {
        this.pageNotFound = true;
        this.$root.$emit('toggleLoadingScreen', false);
      }
    },
    generatePlaceFullInfo() {
      this.placeInfoFull = ContentController.generateContent(this.placeData[0], 'li', true, this.tagId);
      setTimeout(() => {
        document.querySelectorAll('.expandable').forEach(item => {
          item.addEventListener('click', event => {
            this.showMore(event);
          });
        });
        document.querySelectorAll('.payment-description-btn').forEach(item => {
          item.addEventListener('click', event => {
            this.showPaymentOptionInfo(event);
          });
        });
        var elem = document.getElementById('general-description');
        if(elem != null) {
          elem.addEventListener('click', this.checkLink);
        }
        if(this.tagId == 342) {
          const params = new URLSearchParams();
          params.append('action', 'getUserWishLikes');
          params.append('itemId', this.placeId);

          axios({
            method: 'post',
            url: 'https://apps.odenserundt.dk/apptools/orApi/',
            data: params
          }).then((response) => {
            this.userWishLikes = response.data;
            if(response.data.likes != false) {
              this.createUserWishLikesHtml();
            }
          });
        }
      }, 1000);
    },
    getPlaceMapData() {
      DataManager.getData([
        DataManager.newTags+this.tagId+'-dk-light.json',
      ], (response) => {
        let temp = response[0].data.features.filter(feature => feature.id == this.placeId);
        if(temp.length != 0) {
          //Sort placedata to make sure polygons are added to the map first or they end up on top of icons.
          let polygons = temp.filter(feature => feature.geometry.type == 'Polygon');
          polygons.forEach(item => this.placeMapData.push(item));

          let linestrings = temp.filter(feature => feature.geometry.type == 'LineString');
          linestrings.forEach(item => this.placeMapData.push(item));

          let points = temp.filter(feature => feature.geometry.type == 'Point');
          points.forEach(item => this.placeMapData.push(item));
        }
      });
    },
    getPlaceTagInfo() {
      DataFunctions.findPrimaryTag(this.placeData[0]).then((primaryTag) => {
        this.primaryTag = primaryTag;
        //Only check for map params, image is default
        if(this.startup == 'map' || this.startup == 'mapFull' || this.primaryTag.showFirst == 'map' || this.startup == 'routeDescription') {
          this.showImages = false;
          if(this.startup == 'routeDescription') {
            setTimeout(() => {
        			this.RouteCalculator = new RouteCalculator();
        			this.routeResult = this.RouteCalculator.createSimpleRoute(this.placeData[0].id, function() { this.routeDescriptionError() });
              this.showRouteDetails = true;
        		}, 1000);
          }
        }
        let title = this.placeData[0].name+' - '+this.primaryTag.name;
        let description = (this.placeData[0].properties.prop24) ? this.placeData[0].properties.prop24.value.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 200) : '';
        this.$HelperFunctions.generateMetaTags(title, description);

        this.otherTags = DataFunctions.findNonPrimaryTags(this.placeData[0]);
        this.getImageData();
        //Fix for certain places having the route prop but not added route
        if(this.placeData[0].properties.prop105) {
          this.checkForRouteData();
        }
        if(this.placeData[0].properties.prop19) {
          this.getRelatedPlacesData();
          this.hasRelatedPlaces = true;
        }
        else {
          this.$root.$emit('toggleLoadingScreen', false);
        }
        if(localStorage.getItem('OdenseRundt-TutorialPlace') == 'true') {
          this.showPlaceTutorial = true;
        }
      });
  	},
    checkForRouteData() {
      axios({
        method: 'get',
        url: 'https://apps.odenserundt.dk/data/rawroutedata/'+this.placeData[0].id+'.xml',
        responseType: 'xml'
      })
      .then((response) => {
        if(this.placeData[0].properties.prop105.value) {
          this.hasRouteData = true;
				}
      });
    },
  	getRelatedPlacesData() {
      //const relatedPlaces = [];
			const alreadyAdded = [];
      //const urls = [];

			/*for(let i = 0; i < this.placeData[0].properties.prop19.value.length; i++) {
        urls.push(DataManager.newTags+this.placeData[0].properties.prop19.value[i].tag_id+'-dk-light.json');
			}*/

      for(let i = 0; i < this.placeData[0].properties.prop19.value.length; i++) {
        DataManager.getData([
          DataManager.newTags+this.placeData[0].properties.prop19.value[i].tag_id+'-dk-light.json',
        ], (response) => {
          var relatedPlaceShort = this.placeData[0].properties.prop19.value;
          var tagData = response[0].data;

          for(var k = 0; k < tagData.features.length; k++) {
            if(tagData.features[k].id == relatedPlaceShort[i].place_id) {
              return DataFunctions.findPrimaryTag(tagData.features[k]).then((primaryTag) => {
                tagData.features[k].primaryTag = primaryTag;
                tagData.features[k].opacity = true;
                this.placeMapData.push(tagData.features[k]);
                if(alreadyAdded.indexOf(relatedPlaceShort[i].place_id) == -1) {
                  this.relatedPlaces.push(tagData.features[k]);
                  alreadyAdded.push(relatedPlaceShort[i].place_id);
                }
              });
            }
          }
        });
        //console.log(this.relatedPlaces);
        //this.relatedPlaces = relatedPlaces;*/
      }
      this.$root.$emit('toggleLoadingScreen', false);

      /*DataManager.getData(urls, (response) => {
        for(var i = 0; i < response.length; i++) {
          var relatedPlaceShort = this.placeData[0].properties.prop19.value;
          var tag = response[i].data;
          console.log(tag);
          for(var k = 0; k < tag.features.length; k++) {
            if(tag.features[k].id == relatedPlaceShort[i].place_id) {
              console.log(tag.features[k]);

              DataFunctions.findPrimaryTag(tag.features[k]).then((primaryTag) => {
                console.log(tag.features[k]);
                console.log(primaryTag);
                tag.features[k].primaryTag = primaryTag;
                tag.features[k].opacity = true;
                this.placeData.push(tag.features[k]);
                if(alreadyAdded.indexOf(relatedPlaceShort[i].place_id) == -1) {
                  relatedPlaces.push(tag.features[k]);
                  alreadyAdded.push(relatedPlaceShort[i].place_id);
                }
              });
            }
          }
        }
        this.relatedPlaces = relatedPlaces;
      });*/
  	},

    getImageData() {
		  var tempImage = false;
      var place = this.placeData[0].properties;
  		//Check for temporary image
  		if(place.prop117 && place.prop108) {
  			if(place.prop117.value != null && place.prop117.value != undefined && place.prop117.value != 0) {
  				var from = new Date(place.prop117.value.from);
  				var to = new Date(place.prop117.value.to);
  				if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()) {

            this.$HelperFunctions.checkForHighestResolution(place.prop108.value[0].src).then((resolution) => {
              var imgCredit = (place.prop108.value[0].photoCredits != undefined && place.prop108.value[0].photoCredits != 0) ? place.prop108.value[0].photoCredits : '';
              var options = {hasImage: true, resolution: resolution, src: (place.prop108.value[0].src) ? place.prop108.value[0].src : place.prop108.value[0], imgCredit: imgCredit, imageName: this.placeData[0].name+' - '+this.primaryTag.name};
              this.imageData.push(options);
    					tempImage = true;
            });

  				}
  			}
  		}
  		//Check for primary image
  		if(place.prop25) {
        this.$HelperFunctions.checkForHighestResolution(place.prop25.value[0].src).then((resolution) => {
          var imgCredit = (place.prop25.value[0].photoCredits != undefined && place.prop25.value[0].photoCredits != 0) ? place.prop25.value[0].photoCredits : '';
          var primaryImageOptions = {hasImage: true, resolution: resolution, src: (place.prop25.value[0].src) ? place.prop25.value[0].src : place.prop25.value[0], imgCredit: imgCredit, imageName: this.placeData[0].name+' - '+this.primaryTag.name};
          this.imageData.push(primaryImageOptions);
          this.likeImage = primaryImageOptions.src;
        });
  			//Check for extra images
  			if(place.prop33) {
  				if(place.prop33.value.length != 0) {
            place.prop33.value.forEach(item => {
              this.$HelperFunctions.checkForHighestResolution(item.src).then((resolution) => {
                var imgCredit = (item.photoCredits != undefined && item.photoCredits != 0) ? item.photoCredits : '';
                var extraImageOptions = {hasImage: true, resolution: resolution, src: (item.src) ? item.src : item, imgCredit: imgCredit, imageName: this.placeData[0].name+' - '+this.primaryTag.name};
                this.imageData.push(extraImageOptions);
              });
            });
  				}
  			}
  		}
  		else {
        //Generisk billede for alle steder på dette tag
  			if(this.primaryTag.showFirst != 'spot' && this.primaryTag.showFirst != 'map' && !tempImage && this.primaryTag.showFirst != false) {
          this.$HelperFunctions.checkForHighestResolution(this.primaryTag.showFirst).then((resolution) => {
            this.imageData.push({hasImage: true, resolution: resolution, src: this.primaryTag.showFirst, imgCredit: false, imageName: this.placeData[0].name+' - '+this.primaryTag.name});
          });
  			}
        //Intet billede på stedet
        else if(!tempImage && this.primaryTag.showFirst == 'spot') {
          this.imageData.push({hasImage: false, placeId: this.placeData[0].id});
        }
        else {
          this.noImage = true;
        }
  		}
    },

    createUserWishLikesHtml() {
      var html = '<li id="user-wish-likes-li">';
  		var number = this.userWishLikes.likes.length - 3;
  		var length = this.userWishLikes.likes.length;
  		var firstLikes = ''
  		var fullLikes = '';

  		if(length == 1) {
  			firstLikes = this.userWishLikes.likes[0];
  		}
  		else if(length == 2) {
  			firstLikes = this.userWishLikes.likes.join(' og ');
  		}
  		else if(length > 2) {
  			firstLikes = this.userWishLikes.likes.slice(0, 2).join(', ') + ' og '+this.userWishLikes.likes[2];
  			fullLikes = this.userWishLikes.likes.slice(0, -1).join(', ') + ' og '+this.userWishLikes.likes.slice(-1);
  		}

  		html += '<span id="user-wish-likes-few">'+firstLikes+'</span>';

  		html += '<span id="user-wish-likes-full" class="hidden">'+fullLikes+'</span>';

  		if(length == 1) {
  			html += '<span id="user-wish-likes-end-text"> bakker op om dette ønske.</span></li>';
  		}
  		else if(length == 2 || length == 3) {
  			html += '<span id="user-wish-likes-end-text"> bakker op om dette ønske.</span></li>';
  		}
  		else {
  			html += '<span id="user-wish-likes-end-text"> og '+number+' andre brugere bakker op om dette ønske. </span><span id="user-wish-likes-toggle" class="blue-text">Se alle.</span></li>';
  		}
      document.getElementById('user-wish-username-li').insertAdjacentHTML('afterend', html);
  		var toggle = document.getElementById('user-wish-likes-toggle');
      if(toggle != null) {
        toggle.addEventListener('click', function() {
    			if(toggle.innerHTML == 'Se alle.') {
    				toggle.innerHTML = 'Se færre.';
    				document.getElementById('user-wish-likes-end-text').innerHTML = ' bakker op om dette ønske. ';
    				document.getElementById('user-wish-likes-few').classList.add('hidden');
    				document.getElementById('user-wish-likes-full').classList.remove('hidden');
    			}
    			else {
    				toggle.innerHTML = 'Se alle.';
    				document.getElementById('user-wish-likes-end-text').innerHTML = ' og '+number+' andre brugere bakker op om dette ønske. ';
    				document.getElementById('user-wish-likes-few').classList.remove('hidden');
    				document.getElementById('user-wish-likes-full').classList.add('hidden');
    			}
    		});
      }
    },

    showMore(event) {
      if(event.currentTarget.classList.contains('expandable-open')) {
        event.currentTarget.querySelectorAll('.expandable-container')[0].classList.add('hidden');
        event.currentTarget.querySelectorAll('.expandable-icon')[0].querySelectorAll('span')[0].innerHTML = 'keyboard_arrow_down';
      }
      else {
        event.currentTarget.querySelectorAll('.expandable-container')[0].classList.remove('hidden');
        event.currentTarget.querySelectorAll('.expandable-icon')[0].querySelectorAll('span')[0].innerHTML = 'keyboard_arrow_up';
      }
      event.currentTarget.classList.toggle('expandable-open');
    },

    showPaymentOptionInfo(e) {
      e.stopPropagation();
      var target = e.currentTarget.parentNode.querySelector('.payment-description');
			//var btn = e.currentTarget.parentNode.querySelector('.payment-description-btn');
			if(target.classList.contains('hidden')) {
				target.classList.remove('hidden');
        e.currentTarget.innerHTML = ' - Vis ikke info';
			}
			else {
				target.classList.add('hidden');
        e.currentTarget.innerHTML = ' - Vis mere info';
			}
    }
  },
}
</script>

<style lang="scss" scoped>
  .place-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .place-headline {
  	position: relative;
    display: inline-block;
    width: 80%;
  	line-height: 57px;
  	font-size: 20px;
  	margin: 0px;
  }

  .place-basic-information-box {
  	margin-top: 10px;
  }

  .place-basic-information-box a {
  	color: rgb(0,112,141);
  	cursor: pointer;
  }

  .place-information {
  	height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .place-information-wrap {
  	padding-right: 0px;
  }

  .place-page-wrap a {
  	color: rgb(0,112,141);
  }

  .place-info, .place-tags {
  	border-bottom: 1px solid #dedede;
  }

  #place-info-full ::v-deep a {
    text-decoration: underline;
  }

  #place-info-full ::v-deep h5 {
    margin: 10px 0px;
    font-size: 14px;
  }

  #place-info-full ::v-deep li, .extra-info {
  	border-bottom: 1px solid #dedede;
  	padding: 10px 0px 10px 0px;
  }

  #place-info-full ::v-deep .input-headline {
    font-weight: bold;
  }

  #place-info-full ::v-deep .expandable {
    padding: 0 !important;
  }

  #place-info-full ::v-deep .expandable-icon {
    position: relative;
    top: -5px;
  }

  /*Landscape - XS*/
  @media screen and (max-width: 767px) and (orientation: landscape) {
  	.place-info {
  		min-height: 60px;
  	}
  	.place-info, .place-tags, .place-related, .place-contact {
  		padding: 10px 5px 10px 5px;
  	}
  }
  /*Landscape - MD*/
  @media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
  	.place-info, .place-tags, .place-related, .place-contact {
  		/*margin-top: 30px;*/
  		padding: 10px 5px 10px 5px;
  	}
  	.place-information {
  		padding-top: 15px;
  		padding-bottom: 15px;
  	}
  }
  /*Landscape - LG*/
  @media screen and (min-width: 1200px) and (orientation: landscape) {
    .place-tags {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  	.place-information {
  		padding-top: 15px;
  		padding-bottom: 15px;
  	}
  }
  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
  	.place-info {
  		min-height: 60px;
  	}
  	.place-info, .place-tags, .place-related, .place-contact {
  		/*margin-top: 30px;*/
  		padding: 10px 5px 10px 5px;
  	}
  	.place-information {
  		margin-top: 10px;
  		height: auto !important;
  		padding: 0px 5px 0px 5px;
  	}
  	.place-img-container {
  		/*margin-top: 10px;*/
  	}
  }
  /*Portrait - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
  	.place-info, .place-tags, .place-related, .place-contact {
  		/*margin-top: 10px;*/
  		padding: 10px 5px 10px 5px;
  	}
  	.place-information {
  		margin-top: 10px;
  		height: auto !important;
  		padding: 10px 5px 10px 5px;
  	}
  	#place-info-full {
      padding: 10px 5px 10px 5px;
  	}
  	.place-img-container {
  		/*margin-top: 10px;*/
  	}
  }

  .place-tags-div {
  	display: inline-block;
  	padding: 3px 0px 3px 0px;
  	margin: 3px 0px;
  }

  .other-tags-div {
    margin-left: 5px;
  }

  .input-headline {
    font-weight: 700;
  }

  .place-info-contact-value {
    margin: 5px 0;
  }

  /*Related places*/
  .place-related {
  	border-bottom: 1px solid #dedede;
  }

  .related-all, .related-first {
  	padding-bottom: 5px;
  }

  .expandable-container li:last-child {
  	border-bottom: none !important;
  }

  .property-content {
  	max-width: 220px;
  }

  .payment-row:last-child {
  	border: none !important;
  }

  .payment-row i {
  	font-size: 20px !important;
  }

  #directions-btn, #user-wish-support-btn {
  	position: absolute;
  	width: 20%;
    height: 50px;
  	display: inline-block;
  	text-align: center;
  	top: 0px;
  }

  @media screen and (max-width: 767px) and (orientation: portrait) {
    #directions-btn strong, #user-wish-support-btn strong {
      font-size: 11px;
    }
  }

  #user-wish-support-btn {
  	right: 20%;
  }

  #directions-btn {
  	right: 0px;
  }
</style>
